// Define the dropdown options
export const entityTypeOptions = [
  "Artist or Athlete",
  "Business/Organization",
  "Central Bank of Issue",
  "Complex Trust",
  "Corporation",
  "S-Corporation",
  "C-Corporation",
  "P-Corporation",
  "Disclosing Qualified Intermediary",
  "Disregarded Entity",
  "Entity/Disregarded Entity (Single Member LLC)",
  "Estate",
  "Expatriate",
  "Foreign Central Bank of Issue",
  "Foreign Government",
  "Foreign Government - Controlled Entity",
  "Foreign Government - Integral Part",
  "Foreign Private Foundation",
  "Foreign Tax-Exempt Organization",
  "Government",
  "Government of a U.S. Possession",
  "Government or International Organization",
  "Grantor Trust",
  "Hybrid entity making Treaty Claim",
  "Individual",
  "Individual/Sole Proprietor",
  "Individual/Disregarded Entity (Grantor Trust)",
  "International Organization",
  "Individual/Disregarded Entity (Single Member LLC)",
  "Limited Liability Company (Corporation)",
  "Limited Liability Company (Disregarded Entity)",
  "Limited Liability Company (Partnership)",
  "Limited Liability Company (Single-member)",
  "Limited Liability Company (Unknown)",
  "Multiple Types Stated",
  "Non Qualified Intermediary",
  "None",
  "Non-withholding Foreign Grantor Trust",
  "Non-withholding Foreign Partnership",
  "Non-withholding Foreign Simple Trust",
  "Not Listed/Not Stated",
  "Other",
  "Partnership",
  "Partnership other than Withholding Foreign Partnership",
  "Pension",
  "Private Foundation",
  "Qualified Intermediary",
  "Qualified Securities Lender - Other",
  "Qualified Securities Lender - Qualified Intermediary",
  "Simple Trust",
  "Sole Proprietor",
  "Tax-Exempt Organization",
  "Territory FI - not treated as U.S. Person",
  "Territory FI - treated as U.S. Person",
  "Territory Financial Institution",
  "Trust other than Withholding Foreign Trust",
  "Trust/Estate",
  "U.S. Branch",
  "U.S. branch - ECI presumption applied",
  "U.S. branch - not treated as U.S. Person",
  "U.S. Withholding Agent - FI",
  "U.S. Withholding Agent - Other",
  "Unknown Recipient",
  "Withholding Agent",
  "Withholding Foreign Partnership",
  "Withholding Foreign Trust",
  "Withholding qualified holder under section 1445",
  "Government of a U.S. territory",
  "Partnership QDD",
  "U.S. government entity or tax exempt entity (other than section 501(c) entities)",
];

export const entityClassificationOptions = [
  "Not determined",
  "Non-US Financial Institution (FFI)",
  "Not a Financial Institution",
  "Financial Institution (unknown origin)",
  "Affiliated to a US Financial Institution",
  "Affiliated to a Non-US Financial Institution",
  "US Financial Institution",
];
export const incomeCodesDropDownList = [
  "01-Interest (Portfolio Interest)",
  "01-Interest paid by U.S. obligors - general",
  "02-Interest paid on real property mortgages",
  "04-Interest paid by foreign corporations",
  "05-Interest on tax-free covenant bonds",
  "06-Dividends paid by U.S. corporations - general",
  "06-Dividends paid by U.S. corporations - TIN required",
  "07-Dividends qualifying for direct dividend rate",
  "08-Dividends paid by foreign corporations",
  "09-Capital gains",
  "10-Industrial Royalties - Industrial Equipment",
  "10-Industrial Royalties - Know-how/Other Industrial Royalties",
  "10-Industrial Royalties - Patents",
  "11-Motion picture or television copyright royalties",
  "12- Other royalties (for example, copyright, software, broadcasting, endorsement payments)",
  "13-Royalties paid on certain publicly offered securities",
  "14-Real property income and natural resources royalties",
  "15-Pensions, annuities, alimony, and/or insurance premiums",
  "16-Scholarship or fellowship grants",
  "17-Compensation for independent personal services",
  "18-Compensation for dependent personal services",
  "19-Compensation for teaching",
  "20-Compensation during studying and training",
  "21-Social Securities",
  "22-Interest paid on deposit with a foreign branch of a domestic corporation or partnership",
  "23-Gross Income - Other",
  "23- Other income",
  "24- Qualified investment entity (QIE) distribution of capital gains",
  "24- Real estate investment trust (REIT) distributions of capital gains",
  "24- Qualified investment entity (QIE)",
  "25-Trust distributions subject to IRC section 1445",
  "26-Unsevered growing crops and timber distributions by a trust subject to IRC section 1445",
  "27-Publicly traded partnership distributions subject to IRC section 1446(a)",
  "27-Publicly traded partnership distributions subject to IRC section 1446",
  "28-Gambling winnings",
  "38-Eligible deferred compensation items subject to IRC section 877A(d)(1)",
  "29-Deposit interest",
  "30-Original issue discount (OID)",
  "39- Distributions from a nongrantor trust subject to IRC section 877A(f)(1)",
  "40-Other dividend equivalents under IRC section 871(m) (formely 871(I))",
  "40-Other dividend equivalents under IRC section 871(m) (formerly 871(I))",
  "31-Short-term OID",
  "41-Guarantee of indebtedness",
  "32-Notional principal contract income",
  "42-Earnings as an artist or athlete-no central withholding agreement",
  "33-Substitute payment - Interest",
  "43-Earnings as an artist or athlete-central withholding agreement",
  "34-Substitutive payments - dividends",
  "34-Substitute payments - dividends",
  "35-Substitute payment-other",
  "36-Capital gains distributions",
  "37-Return of capital",
  "44-Specified Federal procurement payments",
  "50-Income previously reported under escrow procedure",
  "51-Interest paid on certain actively traded or publicly offered securities",
  "52-Dividends paid on certain actively traded or publicly offered securities",
  "53- Substitute payments - dividends from certain actively traded or publicly offered securities",
  "54- Other income",
  "Ordinary ECI Income",
  "54-Substitute payments - Interest from certain actively traded or publicly offered securites",
  "54-Substitute payments - Interest from certain actively traded or publicly offered securities",
  "55-Taxable death benefits on life insurance contracts",
  "56-Dividend equivalents under IRC section 871(m) as a result of applying the combined transaction rules",
  "57-Amount realized under IRC section 1446(f)",
  "58-Publicly Traded Partnership distributions subject to IRC section 1446(a)",
  "59-Consent fees",
  "60-Loan syndication fees",
  "61-Settlement payments",
  "UK/CRS - United Kingdom or Crown Dependency Income/Exchange of Information Income",
  "Unrecaptured Section 1250 Gain",
  "Long-Term Capital Gain (ECI)",
  "06-Publicly Traded Dividend Withholding Rate",
  "06-Non-Publicly Traded Dividend Withholding Rate",
  "23-Other Portfolio Income Withholding Rate",
  "23-Lease Bonus Settlements Withholding Rate",
  "23-Life Settlement Proceeds Withholding Rate",
  "06-Publicly Traded Diversified REIT Dividend Withholding Rate",
  "06-Publicly Traded Non-Diversified REIT Dividend Withholding Rate",
  "06-Non Publicly Traded Diversified REIT Dividend Withholding Rate",
  "06-Non Publicly Traded Non-Diversified REIT Dividend Withholding Rate",
];

export const formsTypeList = [
  "W-8BEN (Oct 2021)",
  "W-8BEN (July 2017)",
  "W-8BEN (Jan 2017)",
  "W-8BEN (Feb 2014)",
  "W-8BEN (Feb 2006)",
  "W-8BEN (Jan 2006)",
  "W-8BEN (Dec 2000)",
  "W-8BEN (Oct 1998)",
  "W-8BEN (Nov 1992)",
  "W-8BEN-E (Oct 2021)",
  "W-8BEN-E (July 2017)",
  "W-8BEN-E (Apr 2016)",
  "W-8BEN-E (Feb 2014)",
  "W-8CI (Apr 2009)",
  "W-8ECI (Oct 2021)",
  "W-8ECI (July 2017)",
  "W-8ECI (Feb 2014)",
  "W-8ECI (Feb 2006)",
  "W-8ECI (Dec 2000)",
  "W-8ECI (Oct 1998)",
  "W-8EXP (Oct 2023)",
  "W-8EXP (July 2017)",
  "W-8EXP (Sep 2016)",
  "W-8EXP (Apr 2014)",
  "W-8EXP (Feb 2006)",
  "W-8EXP (Dec 2000)",
  "W-8EXP (Oct 1998)",
  "W-8IMY (Oct 2021)",
  "W-8IMY (June 2017)",
  "W-8IMY (Sep 2016)",
  "W-8IMY (Apr 2014)",
  "W-8IMY (Feb 2006)",
  "W-8IMY (Dec 2003)",
  "W-8IMY (Dec 2000)",
  "W-8IMY (Oct 1998)",
  "W-9 (Mar 2024)",
  "W-9 (Oct 2018)",
  "W-9 (Nov 2017)",
  "W-9 (Dec 2014)",
  "W-9 (Aug 2013)",
  "W-9 (Dec 2011)",
  "W-9 (Jan 2011)",
  "W-9 (Oct 2007)",
  "W-9 (Sep 2007)",
  "W-9 (Nov 2005)",
  "W-9 (Jan 2005)",
  "W-9 (Oct 2004)",
  "W-9 (Jan 2003)",
  "W-9 (Jan 2002)",
  "W-9 (Dec 2000)",
  "W-9 (Nov 1999)",
  "W-9 (Dec 1996)",
  "W-9 (Jan 1993)",
  "8233 (Sep 2018)",
  "8233 (Mar 2009)",
  "2018 Cayman Entity Self Cert",
  "Cayman Entity 2018",
  "Cayman Entity 2017",
  "Cayman Entity 2016",
  "Cayman Entity",
  "Cayman Individual 2018",
  "Cayman Individual 2017",
  "Cayman Individual",
  "Generic Entity3",
  "Generic Individual2",
  "Irish Entity",
  "Irish Individual",
  "NonUS Entity",
  "NonUS Individual",
  "Generic Individual3",
  "Generic Entity4",
  "Deloitte US Individual 2024",
  "Deloitte US Entity 2024",
];

export const chapter4StatusOptions = [
  "501(c) organization",
  "Account Holder of Excluded Financial Account",
  "Active NFFE",
  "Account that is not financial account",
  "Certified Deemed Compliant Non-Reporting FFI",
  "Certified Deemed-Compliant FFI - Other",
  "Certified Deemed-Compliant FFI - Sponsored Entity",
  "Certified deemed-compliant FFI with only low-value accounts",
  "Certified deemed-compliant investment advisors and investment managers",
  "Certified deemed-compliant limited life debt investment entity",
  "Certified deemed-compliant nonregistering local bank",
  "Certified deemed-compliant sponsored, closely held investment vehicle",
  "Deemed Compliant FFI",
  "Direct reporting NFFE",
  "Entity wholly owned by exempt beneficial owners",
  "Excepted Active NFFE",
  "Excepted inter-affiliate FFI",
  "Excepted NFFE",
  "Excepted nonfinancial entity in liquidation or bankruptcy",
  "Excepted nonfinancial group entity",
  "Excepted nonfinancial start-up company",
  "Excepted territory NFFE",
  "Exempt Beneficial Owner",
  "Exempt retirement plans",
  "Financial Institution",
  "Financial Institution Resident in US",
  "Foreign central bank of issue",
  "Foreign government, government of a U.S. possession, or foreign central bank of issue",
  "Foreign government (including a political subdivision), government of a U.S. territory, or foreign central bank of issue",
  "Individual",
  "International organization",
  "Irish Financial Institution or a Partner Jurisdiction Financial Institution",
  "Limited Branch",
  "Limited Branch treated as Nonparticipating FFI",
  "Limited FFI treated as Nonparticipating FFI",
  "Local Client Base Financial Institution",
  "NFFE subject to 1472 withholding",
  "Non-consenting U.S. account",
  "None",
  "Nonfinancial group entity",
  "Nonparticipating FFI",
  "Nonprofit organization",
  "Nonreporting IGA FFI",
  "Other",
  "Owner documented FFI",
  "Participating FFI",
  "Participating FFI - Other",
  "Participating FFI - Reporting Model 2 FFI",
  "Passive NFFE",
  "Passive NFFE identifying Substantial U.S. Owners",
  "Passive NFFE reported by FFI",
  "Passive NFFE with no Substantial U.S. Owners",
  "Publicly traded NFFE or NFFE affiliate of a publicly traded corporation",
  "Recalcitrant Account Holder",
  "Registered deemed-compliant FFI",
  "Registered Deemed-Compliant FFI - Other",
  "Registered Deemed-Compliant FFI - Reporting Model 1 FFI",
  "Registered Deemed-Compliant FFI - Sponsored Entity",
  "Reporting Model 1 FFI",
  "Reporting Model 2 FFI",
  "Restricted distributor",
  "Sponsored Closely Held Investment Vehicle",
  "Sponsored direct reporting NFFE",
  "Sponsored FFI",
  "Sponsored FFI that has not obtained a GIIN",
  "Sponsored Investment Entity",
  "Territory FI - not treated as U.S. person",
  "Territory FI - treated as U.S. person",
  "Territory financial institution",
  "Trustee Documented Trust",
  "U.S. Branch",
  "U.S. reportable account",
  "U.S. Withholding Agent - FI",
  "U.S. Withholding Agent - Other",
  "UK Financial Institution or a Partner Jurisdiction Financial Institution",
  "Undocumented Preexisting Obligation",
  "Unknown Recipient",
  "US Financial Institution",
  "U.S. Withholding Agent - Foreign Branch FFI",
  "US Witholding Agent - Foreign Branch FFI",
];

export const allSheetNames = [
  "Business Entities",
  "Additional Addresses",
  "Tax Jurisdictions",
  "Accounts",
  "Income Codes",
  "Account Connections",
  // "Account Balances",
  // "Payment",
  "Forms",
  "Audit",
  "View Forms",
  // 'Version',
  // 'Lists',
];

export const listArray = [
  "Taxpayer Type",
  "Country",
  "Entity type",
  "Capacity",
  "Currency",
  "DocumentaryEvidenceType",
  "BalanceEntitytypes",
  "FatcaReportingBalance",
  "UKCDOTStatus",
  "Form Types",
  "Form Status",
  "Chapter 4 Status",
  "Income codes",
  "1099 Income Type",
  "State",
  "Income Type Default",
  "Income Code",
  "CRS Statuses",
  "Chapter4Status",
  "Recipient Code",
  "Risk Status",
  "Exemption Code",
  "Entity Classification",
  "LegalStatus",
  "Trinary",
  "EntityActivationStatus",
  "AddressType",
  "HybridStatus",
  "Boolean",
  "Year",
  "AllocationMethodology",
];

export const businessList = [
  { field: "UniqueIdentifier", header: "Unique Identifier" },
  { field: "Entity Type", header: "Entity Type" },
  { field: "Entity Classification", header: "Entity Classification" },
  { field: "Chapter4Status", header: "Chapter 4 Status" },
  { field: "Legal Status", header: "Legal Status" },
  { field: "Status", header: "Status" },
  { field: "UK CDOT Status", header: "UK CDOT Status" },
  { field: "CRS Status", header: "CRS Status" },
  { field: "BusinessUnit", header: "Business Unit" },
  { field: "FirstName", header: "First Name" },
  { field: "LastName", header: "Last Name" },
  { field: "CountryOfBirth", header: "Country of Birth" },
  { field: "CountryOfBirthOther", header: "Other Country of Birth" },
  { field: "Date of Birth(MM/DD/YYYY)", header: "Date of Birth (MM/DD/YYYY)" },
  {
    field: "Country Of Citizenship For Tax Purposes",
    header: "Country of Citizenship for Tax Purposes",
  },
  {
    field: "Country Of Citizenship For Tax Purposes Other",
    header: "Other Country of Citizenship for Tax Purposes",
  },
  {
    field: "Country Of Citizenship For Tax Purposes2",
    header: "Country of Citizenship for Tax Purposes 2",
  },
  {
    field: "Country Of Citizenship For Tax Purposes3",
    header: "Country of Citizenship for Tax Purposes 3",
  },
  { field: "Business Name", header: "Business Name" },
  { field: "Doing Business As Name", header: "Doing Business As Name" },
  { field: "Previous Name", header: "Previous Name" },
  { field: "Previous Name Date", header: "Previous Name Date" },
  { field: "Date of Incorporation", header: "Date of Incorporation" },
  { field: "Registration Number", header: "Registration Number" },
  { field: "Business Unit Contact Name", header: "Business Unit Contact Name" },
  { field: "Business Country", header: "Business Country" },
  { field: "CountryOther", header: "Other Country" },
  { field: "Domicile Country", header: "Domicile Country" },
  { field: "TaxPayer ID Type", header: "Taxpayer ID Type" },
  { field: "ATIN", header: "ATIN" },
  { field: "EIN", header: "EIN" },
  { field: "ITIN", header: "ITIN" },
  { field: "PTIN", header: "PTIN" },
  { field: "QIEIN", header: "QIEIN" },
  { field: "SSNOrITIN", header: "SSN or ITIN" },
  { field: "WP-EIN", header: "WP-EIN" },
  { field: "WT-EIN", header: "WT-EIN" },
  { field: "GIIN", header: "GIIN" },
  { field: "ForeignTaxpayerCountry", header: "Foreign Taxpayer Country" },
  { field: "ForeignTaxpayerId", header: "Foreign Taxpayer ID" },
  { field: "VAT", header: "VAT" },
  { field: "IsCheckPerformed", header: "Is Check Performed" },
  { field: "IsSuccessful", header: "Is Successful" },
  { field: "TIN Check Date(MM/DD/YYYY)", header: "TIN Check Date(MM/DD/YYYY)" },
  { field: "1042s payment received", header: "1042s Payment Received" },
  { field: "Address Type", header: "Address Type" },
  { field: "Perm. Address Line1", header: "Permanent Address Line 1" },
  { field: "Perm. Address Line2", header: "Permanent Address Line 2" },
  { field: "Perm. Address Line3", header: "Permanent Address Line 3" },
  { field: "City_Town", header: "City/Town" },
  { field: "State_Province", header: "State/Province" },
  { field: "Perm. Country", header: "Permanent Country" },
  { field: "Perm. CountryOther", header: "Other Permanent Country" },
  { field: "Zip_PostalCode", header: "Zip/Postal Code" },
  { field: "Mail Address Type", header: "Mail Address Type" },
  { field: "Mail Address Line1", header: "Mail Address Line 1" },
  { field: "Mail Address Line2", header: "Mail Address Line 2" },
  { field: "Mail Address Line3", header: "Mail Address Line 3" },
  { field: "Mail City_Town", header: "Mail City/Town" },
  { field: "State_Province2", header: "Mail State/Province" },
  { field: "Mail Country", header: "Mail Country" },
  { field: "Mail CountryOther", header: "Other Mail Country" },
  { field: "Mail Zip_PostalCode", header: "Mail Zip/Postal Code" },
  { field: "Contact Name", header: "Contact Name" },
  { field: "Contact Email", header: "Contact Email" },
  { field: "Contact Name2", header: "Contact Name 2" },
  { field: "Contact Email2", header: "Contact Email 2" },
  { field: "Contact Name3", header: "Contact Name 3" },
  { field: "Contact Email3", header: "Contact Email 3" },
  { field: "Contact CellNumber Country", header: "Contact Cell Number Country" },
  { field: "Contact  CellNumber", header: "Contact Cell Number" },
  { field: "Contact Telephone Country", header: "Contact Telephone Country" },
  { field: "Contact  TelephoneNumber", header: "Contact Telephone Number" },
  { field: "Contact Telephone Country2", header: "Contact Telephone Country 2" },
  { field: "Contact  TelephoneNumber2", header: "Contact Telephone Number 2" },
  { field: "HybridStatus", header: "Hybrid Status" },
  { field: "IsUSPerson", header: "Is US Person" },
  { field: "IsUSGreenCardHolder", header: "Is US Green Card Holder" },
  { field: "Is US Person Classification", header: "US Person Classification" },
  { field: "IsDualCitizenshipHolder", header: "Is Dual Citizenship Holder" },
  {
    field: "DoesDualCitizenshipIncludeUnitedStates",
    header: "Does Dual Citizenship Include United States",
  },
  { field: "IsBornOrganisedInUS", header: "Is Born or Organised in US" },
  { field: "HasRenouncedCitizenship", header: "Has Renounced Citizenship" },
  { field: "InUSA31DaysCurrentYear", header: "In USA 31 Days This Year" },
  { field: "DaysInCurrentYear", header: "Days in Current Year" },
  { field: "DaysInPrecedingYear", header: "Days in Preceding Year" },
  { field: "DaysInFurtherPrecedingYear", header: "Days in Further Preceding Year" },
  { field: "DeceasedOn", header: "Deceased On" },
  { field: "Notes", header: "Notes" },
  { field: "AltVendorID1", header: "Alternate Vendor ID 1" },
  { field: "AltVendorID2", header: "Alternate Vendor ID 2" },
  { field: "AltVendorID3", header: "Alternate Vendor ID 3" },
  { field: "Signed Certification Confirmation", header: "Signed Certification Confirmation" },
  {
    field: "Signed Certification Confirmation Date",
    header: "Signed Certification Confirmation Date",
  },
  { field: "VATCountry", header: "VAT Country" },
  { field: "VATCheckPerformed", header: "VAT Check Performed" },
  { field: "VATCheckIsSuccessful", header: "VAT Check Is Successful" },
  { field: "VATCheckDate", header: "VAT Check Date (MM/DD/YYYY)" },
  {
    field: "CompanyRegistrationNumberOrEIN",
    header: "Company registration number or an Entity Identification Number (EIN)",
  },
  {
    field: "CompanyRegistrationNumberOrEINIssuedBy",
    header: "Company registration number or an Entity Identification Number (EIN) Issued by",
  },
  {
    field: "CompanyRegistrationNumberOrEINType",
    header: "Company registration number or an Entity Identification Number (EIN) Type",
  },
  { field: "GVSJurisdiction", header: "GVS Jurisdiction" },
  { field: "GVSReferenceNumber", header: "GVS Reference number" },
  { field: "DAC7ReportingRequired", header: "DAC7 Reporting Required" },
  { field: "USTINClassificationForEIN", header: "US TIN classification (for EIN)" },
  { field: "USTINClassificationForSSN", header: "US TIN classification (for SSN)" },
];

export const addressList = [
  "UniqueIdentifier",
  "Address Type",
  "Address Line1",
  "Address Line2",
  "Address Line3",
  "City_Town",
  "State_Province",
  "Country",
  "CountryOther",
  "Zip_PostalCode",
];
// export const accountConnectionsList = ['Parent',
//     'Child',
//     'Allocation',
//     'Capital Committed (Amount $)',
//     'Date MM-DD-YYYY',];

export const accountConnectionsList = [
  { field: "Parent", header: "Parent" },
  { field: "Child", header: "Child" },
  { field: "Allocation", header: "Allocation" },
  { field: "Capital Committed (Amount $)", header: "Capital Committed (Amount $)" },
  { field: "Date MM-DD-YYYY", header: "Date (MM-DD-YYYY)" },
];
export const taxList = ["UniqueIdentifier", "JurisdictionTaxCountry", "TIN", "IsTINAvailable"];
export const accountsList = [
  { field: "Number", header: "Account Number" },
  { field: "Name", header: "Account Name" },
  { field: "Recipient Code", header: "Recipient Code" },
  { field: "OpenedOn", header: "Opened On" },
  { field: "ClosedOn", header: "Closed On" },
  { field: "Risk Status", header: "Risk Status" },
  { field: "IsFlowThroughAccount", header: "Is Flow Through Account" },
  { field: "Assume Primary WHR", header: "Assume Primary WHR" },
  { field: "Aggregate WHR 0%", header: "Aggregate WHR 0%" },
  { field: "EntityUID", header: "Entity UID" },
  { field: "Signatory Entity ID", header: "Signatory Entity ID" },
  { field: "Signatory Capacity", header: "Signatory Capacity" },
  { field: "CapacityOther", header: "Other Capacity" },
  { field: "Bank Name", header: "Bank Name" },
  { field: "Bank Account Number", header: "Bank Account Number" },
  { field: "Sort Code", header: "Sort Code" },
  { field: "SWIFT Code", header: "SWIFT Code" },
  { field: "ABA Number", header: "ABA Number" },
  { field: "Cheque Payment", header: "Cheque Payment" },
  { field: "Remittance Name", header: "Remittance Name" },
  { field: "Remittance Address Line 1", header: "Remittance Address Line 1" },
  { field: "Remittance Address Line2", header: "Remittance Address Line 2" },
  { field: "Remittance City_Town", header: "Remittance City/Town" },
  { field: "Remittance State_Province", header: "Remittance State/Province" },
  { field: "Remittance Country", header: "Remittance Country" },
  { field: "Remittance CountryOther", header: "Other Remittance Country" },
  { field: "Remittance Zip_PostalCode", header: "Remittance Zip/Postal Code" },
  { field: "Allocation Methodology", header: "Allocation Methodology" },
];

export const incomeList = [
  { field: "Number", header: "Account Number" },
  { field: "Income Type", header: "Income Type" },
  { field: "Income Code", header: "Income Code" },
  { field: "Exemption Code", header: "Exemption Code" },
  { field: "Apply Exemption to All Accounts", header: "Apply Exemption to All Accounts" },
  {
    field: "Manual Withholding Rate (%) (Format: 00.00)",
    header: "Manual Withholding Rate (%) (Format: 00.00)",
  },
];
export const accountBalancesList = [
  "Entity UID",
  "Entity Type",
  "Account Number",
  "Year",
  "Dormant",
  "FATCA Reporting Balance",
  "This Account Balance",
  "Interest",
  "Dividends",
  "Gross Proceeds",
  "Other",
  "Currency Code",
];
export const paymentList = [
  "Account Number",
  "Invoice Number",
  "SAP ID",
  "Payment Date (mm/dd/yyyy)",
  "1099 Income Type",
  "1042 Income Code",
  "Exemption Code",
  "Percentage of US Income",
  "Gross Amount",
  "Expenses",
];
export const formsList = [
  "UID",
  "First name",
  "Last name",
  "Business name",
  "Form type and revision",
  "Entity Type",
  "FATCA Entity Types",
  "Signature date (mm/dd/yyyy)",
  "Treaty country",
  "Active Status",
  "LOB Code applied",
  "Tax Form Foreign Tax ID",
  "Foreign Tax Country",
  "Tax Identification Type",
  "Tax Identification Number",
  "Self-cert Primary Jurisdiction2",
  "Self-cert Primary Jurisdiction TIN",
  "Self-cert Additional Jurisdiction1",
  "Self-cert Additional Jurisdiction1 TIN",
  "Self-cert Additional Jurisdiction2",
  "Self-cert Additional Jurisdiction2 TIN",
];
export const versionList = ["1.5"];
export const statesList = [
  "Alabama (AL)",
  "Alaska (AK)",
  "Alberta (AB)",
  "Arizona (AZ)",
  "Arkansas (AR)",
  "British Columbia (BC)",
  "California (CA)",
  "Colorado (CO)",
  "Connecticut (CT)",
  "Delaware (DE)",
  "District of Columbia (DC)",
  "Florida (FL)",
  "Georgia (GA)",
  "Hawaii (HI)",
  "Idaho (ID)",
  "Illinois (IL)",
  "Indiana (IN)",
  "Iowa (IA)",
  "Kansas (KS)",
  "Kentucky (KY)",
  "Louisiana (LA)",
  "Maine (ME)",
  "Manitoba (MB)",
  "Maryland (MD)",
  "Massachusetts (MA)",
  "Michigan (MI)",
  "Minnesota (MN)",
  "Mississippi (MS)",
  "Missouri (MO)",
  "Montana (MT)",
  "Nebraska (NE)",
  "Nevada (NV)",
  "New Brunswick (NB)",
  "New Hampshire (NH)",
  "New Jersey (NJ)",
  "New Mexico (NM)",
  "New York (NY)",
  "Newfoundland and Labrador (NF)",
  "North Carolina (NC)",
  "North Dakota (ND)",
  "Northwest Territories (NT)",
  "Nova Scotia (NS)",
  "Nunavut (NU)",
  "Ohio (OH)",
  "Oklahoma (OK)",
  "Ontario (ON)",
  "Oregon (OR)",
  "Pennsylvania (PA)",
  "Prince Edward Island (PE)",
  "Puerto Rico (PR)",
  "Quebec (QC)",
  "Rhode Island (RI)",
  "Saskatchewan (SK)",
  "South Carolina (SC)",
  "South Dakota (SD)",
  "Tennessee (TN)",
  "Texas (TX)",
  "Utah (UT)",
  "Vermont (VT)",
  "Virgin Islands (VI)",
  "Virginia (VA)",
  "Washington (WA)",
  "West Virginia (WV)",
  "Wisconsin (WI)",
  "Wyoming (WY)",
  "Yukon (YT)",
];

export const usLocations = [
  "Alabama (AL)",
  "Alaska (AK)",
  "Arizona (AZ)",
  "Arkansas (AR)",
  "California (CA)",
  "Colorado (CO)",
  "Connecticut (CT)",
  "Delaware (DE)",
  "District of Columbia (DC)",
  "Florida (FL)",
  "Georgia (GA)",
  "Hawaii (HI)",
  "Idaho (ID)",
  "Illinois (IL)",
  "Indiana (IN)",
  "Iowa (IA)",
  "Kansas (KS)",
  "Kentucky (KY)",
  "Louisiana (LA)",
  "Maine (ME)",
  "Maryland (MD)",
  "Massachusetts (MA)",
  "Michigan (MI)",
  "Minnesota (MN)",
  "Mississippi (MS)",
  "Missouri (MO)",
  "Montana (MT)",
  "Nebraska (NE)",
  "Nevada (NV)",
  "New Hampshire (NH)",
  "New Jersey (NJ)",
  "New Mexico (NM)",
  "New York (NY)",
  "North Carolina (NC)",
  "North Dakota (ND)",
  "Ohio (OH)",
  "Oklahoma (OK)",
  "Oregon (OR)",
  "Pennsylvania (PA)",
  "Puerto Rico (PR)",
  "Rhode Island (RI)",
  "South Carolina (SC)",
  "South Dakota (SD)",
  "Tennessee (TN)",
  "Texas (TX)",
  "Utah (UT)",
  "Vermont (VT)",
  "Virgin Islands (VI)",
  "Virginia (VA)",
  "Washington (WA)",
  "West Virginia (WV)",
  "Wisconsin (WI)",
  "Wyoming (WY)",
];

export const canadianLocations = [
  "Alberta (AB)",
  "British Columbia (BC)",
  "Manitoba (MB)",
  "New Brunswick (NB)",
  "Newfoundland and Labrador (NF)",
  "Northwest Territories (NT)",
  "Nova Scotia (NS)",
  "Nunavut (NU)",
  "Ontario (ON)",
  "Prince Edward Island (PE)",
  "Quebec (QC)",
  "Saskatchewan (SK)",
  "Yukon (YT)",
];
export const LegalStatus = [
  "Corporation",
  "Foundation",
  "General Partnership",
  "Limited Liability Company",
  "Limited Partnership",
  "Private Limited Company",
  "Public Limited Company",
  "Sole Trader",
  "Trust",
  "Unknown",
];
export const RecipientCode = [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
];

export const auditColumnNames = [
  { field: "dataType", header: "Data Type" },
  { field: "action", header: "Action" },
  { field: "uid", header: "Unique Identifier" },
  { field: "fieldName", header: "Field Name" },
  { field: "oldValue", header: "Old Value" },
  { field: "newValue", header: "New Value" },
  { field: "userName", header: "User Name" },
  { field: "modifiedDate", header: "Modified Date" },
];
export const extractedColumnNames = [
  { field: "Name", header: "Name" },
  { field: "Number", header: "Number" },
  { field: "Entity Type", header: "Entity Type" },
  { field: "Entity Classification", header: "Entity Classification" },
  { field: "Chapter4Status", header: "Chapter 4 Status" },
  { field: "EIN", header: "EIN" },
  { field: "SSNOrITIN", header: "SSN or ITIN" },
  { field: "GIIN", header: "GIIN" },
  { field: "ForeignTaxpayerId", header: "Foreign Taxpayer ID" },
  { field: "Perm. Country", header: "Permanent Country" },
  { field: "Perm. Address Line1", header: "Permanent Address Line 1" },
  { field: "Allocation", header: "Allocation" },
];
//Global Intermediary Identification Number (GIIN)
//Employer Identification Number (EIN)

export const forms = [
  { field: "UID", header: "UID" },
  { field: "First name", header: "First Name" },
  { field: "Last name", header: "Last Name" },
  { field: "Business name", header: "Business Name" },
  { field: "Form type and revision", header: "Form Type and Revision" },
  { field: "Entity Type", header: "Entity Type" },
  { field: "FATCA Entity Types", header: "FATCA Entity Types" },
  { field: "Signature date (mm/dd/yyyy)", header: "Signature Date (MM/DD/YYYY)" },
  { field: "Treaty country", header: "Treaty Country" },
  { field: "Active Status", header: "Active Status" },
  { field: "LOB Code applied", header: "LOB Code Applied" },
  { field: "Tax Form Foreign Tax ID", header: "Tax Form Foreign Tax ID" },
  { field: "Foreign Tax Country", header: "Foreign Tax Country" },
  { field: "Tax Identification Type", header: "Tax Identification Type" },
  { field: "Tax Identification Number", header: "Tax Identification Number" },
  { field: "Self-cert Primary Jurisdiction2", header: "Self-Cert Primary Jurisdiction" },
  { field: "Self-cert Primary Jurisdiction TIN", header: "Self-Cert Primary Jurisdiction TIN" },
  { field: "Self-cert Additional Jurisdiction1", header: "Self-Cert Additional Jurisdiction 1" },
  {
    field: "Self-cert Additional Jurisdiction1 TIN",
    header: "Self-Cert Additional Jurisdiction 1 TIN",
  },
  { field: "Self-cert Additional Jurisdiction2", header: "Self-Cert Additional Jurisdiction 2" },
  {
    field: "Self-cert Additional Jurisdiction2 TIN",
    header: "Self-Cert Additional Jurisdiction 2 TIN",
  },
  { field: "CRS Status", header: "CRS Status" },
  { field: "Permanent Address Line1", header: "Permanent Address Line 1" },
  { field: "Permanent Address Line2", header: "Permanent Address Line 2" },
  { field: "Permanent Address Line3", header: "Permanent Address Line 3" },
  { field: "Permanent City Town", header: "Permanent City/Town" },
  { field: "Permanent State Province", header: "Permanent State/Province" },
  { field: "Permanent Country", header: "Permanent Country" },
  { field: "Permanent Country Other", header: "Permanent Country Other" },
  { field: "Permanent ZIP Postal Code", header: "Permanent ZIP/Postal Code" },
  { field: "Permanent Is care-of-address", header: "Permanent Is Care-of-Address" },
  { field: "Permanent Is P.O. Box", header: "Permanent Is P.O. Box" },
  { field: "Permanent Is rural route", header: "Permanent Is Rural Route" },
  { field: "Country of Citizenship", header: "Country of Citizenship" },
  {
    field: "Country of incorporation or organization",
    header: "Country of Incorporation or Organization",
  },
  { field: "Name of disregarded entity", header: "Name of Disregarded Entity" },
  {
    field: "Hybrid Entity Claiming Treaty Benefits",
    header: "Hybrid Entity Claiming Treaty Benefits",
  },
  { field: "W-8EXP Line 10b", header: "W-8EXP Line 10b" },
  { field: "W-8EXP Line 10c", header: "W-8EXP Line 10c" },
  { field: "Nonreporting IGA FFI Model 1 IGA", header: "Nonreporting IGA FFI Model 1 IGA" },
  { field: "Nonreporting IGA FFI Model 2 IGA", header: "Nonreporting IGA FFI Model 2 IGA" },
  { field: "W-9 Exempt payee code", header: "W-9 Exempt payee code" },
  {
    field: "W-9 Exempt payee code Multiple selections",
    header: "W-9 Exempt payee code Multiple selections",
  },
  { field: "W-9 Exempt payee code Enter the text", header: "W-9 Exempt payee code Enter the text" },
  {
    field: "W-9 Exempt payee code Unknown selection (illegible)",
    header: "W-9 Exempt payee code Unknown selection (illegible)",
  },
  {
    field: "W-9 Exemption from FATCA reporting code",
    header: "W-9 Exemption from FATCA reporting code",
  },
  {
    field: "W-9 Exemption from FATCA reporting code Multiple selections",
    header: "W-9 Exemption from FATCA reporting code Multiple selections",
  },
  {
    field: "W-9 Exemption from FATCA reporting code Enter the text",
    header: "W-9 Exemption from FATCA reporting code Enter the text",
  },
  {
    field: "W-9 Exemption from FATCA reporting code Unknown selection (illegible)",
    header: "W-9 Exemption from FATCA reporting code Unknown selection (illegible)",
  },
  { field: "Mailing address Line1", header: "Mailing address Line1" },
  { field: "Mailing address Line2", header: "Mailing address Line2" },
  { field: "Mailing address Line3", header: "Mailing address Line3" },
  { field: "Mailing address City / Town", header: "Mailing address City / Town" },
  { field: "Mailing address State Province", header: "Mailing address State Province" },
  { field: "Mailing address ZIP Postal Code", header: "Mailing address ZIP Postal Code" },
  { field: "Mailing address Country", header: "Mailing address Country" },
  { field: "Mailing address Country Other", header: "Mailing address Country Other" },
  { field: "Mailing Is care-of-address", header: "Mailing Is care-of-address" },
  { field: "Mailing Is P.O. Box", header: "Mailing Is P.O. Box" },
  { field: "Mailing Is rural route", header: "Mailing Is rural route" },
  { field: "Date of birth (mm-dd-yyyy)", header: "Date of birth (mm-dd-yyyy)" },
  { field: "Check if FTIN not legally required", header: "Check if FTIN not legally required" },
  { field: "GIIN", header: "GIIN" },
  { field: "Reference Numbers", header: "Reference Numbers" },
  { field: "Disregarded Entity (FATCA status)", header: "Disregarded Entity (FATCA status)" },
  { field: "Disregarded entity address Line 1", header: "Disregarded entity address Line 1" },
  { field: "Disregarded entity address Line 2", header: "Disregarded entity address Line 2" },
  { field: "Disregarded entity City / town", header: "Disregarded entity City / town" },
  {
    field: "Disregarded entity address State Province",
    header: "Disregarded entity address State Province",
  },
  {
    field: "Disregarded entity address Zip Postal Code",
    header: "Disregarded entity address Zip Postal Code",
  },
  { field: "Disregarded entity address Country", header: "Disregarded entity address Country" },
  { field: "Disregarded entity GIIN", header: "Disregarded entity GIIN" },
  {
    field: "LOB Other (Specify Article and Paragraph)",
    header: "LOB Other (Specify Article and Paragraph)",
  },
  { field: "Claimed Article", header: "Claimed Article" },
  { field: "Claimed Paragraph", header: "Claimed Paragraph" },
  { field: "Subparagraph Information (if any)", header: "Subparagraph Information (if any)" },
  { field: "Claimed Percentage", header: "Claimed Percentage" },
  { field: "Claimed type of income", header: "Claimed type of income" },
  { field: "Claimed Article1", header: "Claimed Article1" },
  { field: "Claimed Paragraph1", header: "Claimed Paragraph1" },
  { field: "Subparagraph Information (if any)1", header: "Subparagraph Information (if any)1" },
  { field: "Claimed Percentage1", header: "Claimed Percentage1" },
  { field: "Claimed type of income1", header: "Claimed type of income1" },
  { field: "Claimed Explanation", header: "Claimed Explanation" },
  { field: "Self-Cert - Place of birth", header: "Self-Cert - Place of birth" },
  { field: "Self-Cert - Country of birth", header: "Self-Cert - Country of birth" },
  { field: "Self-Cert - TIN Type", header: "Self-Cert - TIN Type" },
  {
    field: "Self-Cert - Reason for non-availability of a TIN",
    header: "Self-Cert - Reason for non-availability of a TIN",
  },
  { field: "Self-Cert - TIN Type1", header: "Self-Cert - TIN Type1" },
  {
    field: "Self-Cert - Reason for non-availability of a TIN1",
    header: "Self-Cert - Reason for non-availability of a TIN1",
  },
  { field: "Self-Cert - TIN Type2", header: "Self-Cert - TIN Type2" },
  {
    field: "Self-Cert - Reason for non-availability of a TIN2",
    header: "Self-Cert - Reason for non-availability of a TIN2",
  },
  { field: "Self-Cert - TIN Type3", header: "Self-Cert - TIN Type3" },
  {
    field: "Self-Cert - Reason for non-availability of a TIN3",
    header: "Self-Cert - Reason for non-availability of a TIN3",
  },
  { field: "Capacity", header: "Capacity" },
  { field: "Entity type2", header: "Entity type2" },
  { field: "Nonreporting IGA FFI Treated as", header: "Nonreporting IGA FFI Treated as" },
  { field: "Nonreporting IGA FFI Country", header: "Nonreporting IGA FFI Country" },
  { field: "Is signed", header: "Is signed" },
  { field: "Print Name", header: "Print Name" },
  { field: "Position/Title", header: "Position/Title" },
  { field: "Controlling Person 1 First Name", header: "Controlling Person 1 First Name" },
  { field: "Controlling Person 1 Last Name", header: "Controlling Person 1 Last Name" },
  {
    field: "Controlling Person 1 Permanent Address Line1",
    header: "Controlling Person 1 Permanent Address Line1",
  },
  {
    field: "Controlling Person 1 Permanent Address Line2",
    header: "Controlling Person 1 Permanent Address Line2",
  },
  {
    field: "Controlling Person 1 Permanent Address Line3",
    header: "Controlling Person 1 Permanent Address Line3",
  },
  {
    field: "Controlling Person 1 Permanent City Town",
    header: "Controlling Person 1 Permanent City Town",
  },
  {
    field: "Controlling Person 1 Permanent State Province",
    header: "Controlling Person 1 Permanent State Province",
  },
  {
    field: "Controlling Person 1 Permanent Country",
    header: "Controlling Person 1 Permanent Country",
  },
  {
    field: "Controlling Person 1 Permanent Country Other",
    header: "Controlling Person 1 Permanent Country Other",
  },
  {
    field: "Controlling Person 1 Permanent ZIP Postal Code",
    header: "Controlling Person 1 Permanent ZIP Postal Code",
  },
  {
    field: "Controlling Person 1 Date of Birth (MM/DD/YYYY)",
    header: "Controlling Person 1 Date of Birth (MM/DD/YYYY)",
  },
  {
    field: "Controlling Person 1 Country of birth",
    header: "Controlling Person 1 Country of birth",
  },
  {
    field: "Controlling Person 1 Tax Residence Country 1",
    header: "Controlling Person 1 Tax Residence Country 1",
  },
  {
    field: "Controlling Person 1 Tax Residence Country 1 TIN",
    header: "Controlling Person 1 Tax Residence Country 1 TIN",
  },
  {
    field: "Controlling Person 1 Tax Residence Country 2",
    header: "Controlling Person 1 Tax Residence Country 2",
  },
  {
    field: "Controlling Person 1 Tax Residence Country 2 TIN",
    header: "Controlling Person 1 Tax Residence Country 2 TIN",
  },
  {
    field: "Controlling Person 1 Tax Residence Country 3",
    header: "Controlling Person 1 Tax Residence Country 3",
  },
  {
    field: "Controlling Person 1 Tax Residence Country 3 TIN",
    header: "Controlling Person 1 Tax Residence Country 3 TIN",
  },
  {
    field: "Controlling Person 1 Tax Residence Country 4",
    header: "Controlling Person 1 Tax Residence Country 4",
  },
  {
    field: "Controlling Person 1 Tax Residence Country 4 TIN",
    header: "Controlling Person 1 Tax Residence Country 4 TIN",
  },
  {
    field: "Controlling Person 1 Type of Controlling Person",
    header: "Controlling Person 1 Type of Controlling Person",
  },
  { field: "Controlling Person 2 First Name", header: "Controlling Person 2 First Name" },
  { field: "Controlling Person 2 Last Name", header: "Controlling Person 2 Last Name" },
  {
    field: "Controlling Person 2 Permanent Address Line1",
    header: "Controlling Person 2 Permanent Address Line1",
  },
  {
    field: "Controlling Person 2 Permanent Address Line2",
    header: "Controlling Person 2 Permanent Address Line2",
  },
  {
    field: "Controlling Person 2 Permanent Address Line3",
    header: "Controlling Person 2 Permanent Address Line3",
  },
  {
    field: "Controlling Person 2 Permanent City Town",
    header: "Controlling Person 2 Permanent City Town",
  },
  {
    field: "Controlling Person 2 Permanent State Province",
    header: "Controlling Person 2 Permanent State Province",
  },
  {
    field: "Controlling Person 2 Permanent Country",
    header: "Controlling Person 2 Permanent Country",
  },
  {
    field: "Controlling Person 2 Permanent Country Other",
    header: "Controlling Person 2 Permanent Country Other",
  },
  {
    field: "Controlling Person 2 Permanent ZIP Postal Code",
    header: "Controlling Person 2 Permanent ZIP Postal Code",
  },
  {
    field: "Controlling Person 2 Date of Birth (MM/DD/YYYY)",
    header: "Controlling Person 2 Date of Birth (MM/DD/YYYY)",
  },
  {
    field: "Controlling Person 2 Country of birth",
    header: "Controlling Person 2 Country of birth",
  },
  {
    field: "Controlling Person 2 Tax Residence Country1",
    header: "Controlling Person 2 Tax Residence Country1",
  },
  {
    field: "Controlling Person 2 Tax Residence Country 1 TIN",
    header: "Controlling Person 2 Tax Residence Country 1 TIN",
  },
  {
    field: "Controlling Person 2 Tax Residence Country 2",
    header: "Controlling Person 2 Tax Residence Country 2",
  },
  {
    field: "Controlling Person 2 Tax Residence Country 2 TIN",
    header: "Controlling Person 2 Tax Residence Country 2 TIN",
  },
  {
    field: "Controlling Person 2 Tax Residence Country 3",
    header: "Controlling Person 2 Tax Residence Country 3",
  },
  {
    field: "Controlling Person 3 Tax Residence Country 3 TIN",
    header: "Controlling Person 3 Tax Residence Country 3 TIN",
  },
  {
    field: "Controlling Person 2 Tax Residence Country 4",
    header: "Controlling Person 2 Tax Residence Country 4",
  },
  {
    field: "Controlling Person 2 Tax Residence Country 4 TIN",
    header: "Controlling Person 2 Tax Residence Country 4 TIN",
  },
  {
    field: "Controlling Person 2 Type of Controlling Person",
    header: "Controlling Person 2 Type of Controlling Person",
  },
  { field: "Controlling Person 3 First Name", header: "Controlling Person 3 First Name" },
  { field: "Controlling Person 3 Last Name", header: "Controlling Person 3 Last Name" },
  {
    field: "Controlling Person 3 Permanent Address Line1",
    header: "Controlling Person 3 Permanent Address Line1",
  },
  {
    field: "Controlling Person 3 Permanent Address Line2",
    header: "Controlling Person 3 Permanent Address Line2",
  },
  {
    field: "Controlling Person 3 Permanent Address Line3",
    header: "Controlling Person 3 Permanent Address Line3",
  },
  {
    field: "Controlling Person 3 Permanent City Town",
    header: "Controlling Person 3 Permanent City Town",
  },
  {
    field: "Controlling Person 3 Permanent State Province",
    header: "Controlling Person 3 Permanent State Province",
  },
  {
    field: "Controlling Person 3 Permanent Country",
    header: "Controlling Person 3 Permanent Country",
  },
  {
    field: "Controlling Person 3 Permanent Country Other",
    header: "Controlling Person 3 Permanent Country Other",
  },
  {
    field: "Controlling Person 3 Permanent ZIP Postal Code",
    header: "Controlling Person 3 Permanent ZIP Postal Code",
  },
  {
    field: "Controlling Person 3 Date of Birth (MM/DD/YYYY)",
    header: "Controlling Person 3 Date of Birth (MM/DD/YYYY)",
  },
  {
    field: "Controlling Person 3 Country of birth",
    header: "Controlling Person 3 Country of birth",
  },
  {
    field: "Controlling Person 3 Tax Residence Country1",
    header: "Controlling Person 3 Tax Residence Country1",
  },
  {
    field: "Controlling Person 3 Tax Residence Country 1 TIN",
    header: "Controlling Person 3 Tax Residence Country 1 TIN",
  },
  {
    field: "Controlling Person 3 Tax Residence Country 2",
    header: "Controlling Person 3 Tax Residence Country 2",
  },
  {
    field: "Controlling Person 3 Tax Residence Country 2 TIN",
    header: "Controlling Person 3 Tax Residence Country 2 TIN",
  },
  {
    field: "Controlling Person 3 Tax Residence Country 3",
    header: "Controlling Person 3 Tax Residence Country 3",
  },
  {
    field: "Controlling Person 3 Tax Residence Country 3 TIN2",
    header: "Controlling Person 3 Tax Residence Country 3 TIN2",
  },
  {
    field: "Controlling Person 3 Tax Residence Country 4",
    header: "Controlling Person 3 Tax Residence Country 4",
  },
  {
    field: "Controlling Person 3 Tax Residence Country 4 TIN",
    header: "Controlling Person 3 Tax Residence Country 4 TIN",
  },
  {
    field: "Controlling Person 3 Type of Controlling Person",
    header: "Controlling Person 3 Type of Controlling Person",
  },
  { field: "Controlling Person 4 First Name", header: "Controlling Person 4 First Name" },
  { field: "Controlling Person 4 Last Name", header: "Controlling Person 4 Last Name" },
  {
    field: "Controlling Person 4 Permanent Address Line1",
    header: "Controlling Person 4 Permanent Address Line1",
  },
  {
    field: "Controlling Person 4 Permanent Address Line2",
    header: "Controlling Person 4 Permanent Address Line2",
  },
  {
    field: "Controlling Person 4 Permanent Address Line3",
    header: "Controlling Person 4 Permanent Address Line3",
  },
  {
    field: "Controlling Person 4 Permanent City Town",
    header: "Controlling Person 4 Permanent City Town",
  },
  {
    field: "Controlling Person 4 Permanent State Province",
    header: "Controlling Person 4 Permanent State Province",
  },
  {
    field: "Controlling Person 4 Permanent Country",
    header: "Controlling Person 4 Permanent Country",
  },
  {
    field: "Controlling Person 4 Permanent Country Other",
    header: "Controlling Person 4 Permanent Country Other",
  },
  {
    field: "Controlling Person 4 Permanent ZIP Postal Code",
    header: "Controlling Person 4 Permanent ZIP Postal Code",
  },
  {
    field: "Controlling Person 4 Date of Birth (MM/DD/YYYY)",
    header: "Controlling Person 4 Date of Birth (MM/DD/YYYY)",
  },
  {
    field: "Controlling Person 4 Country of birth",
    header: "Controlling Person 4 Country of birth",
  },
  {
    field: "Controlling Person 4 Tax Residence Country1",
    header: "Controlling Person 4 Tax Residence Country1",
  },
  {
    field: "Controlling Person 4 Tax Residence Country 1 TIN",
    header: "Controlling Person 4 Tax Residence Country 1 TIN",
  },
  {
    field: "Controlling Person 4 Tax Residence Country 2",
    header: "Controlling Person 4 Tax Residence Country 2",
  },
  {
    field: "Controlling Person 4 Tax Residence Country 2 TIN",
    header: "Controlling Person 4 Tax Residence Country 2 TIN",
  },
  {
    field: "Controlling Person 4 Tax Residence Country 3",
    header: "Controlling Person 4 Tax Residence Country 3",
  },
  {
    field: "Controlling Person 4 Tax Residence Country 3 TIN",
    header: "Controlling Person 4 Tax Residence Country 3 TIN",
  },
  {
    field: "Controlling Person 4 Tax Residence Country 4",
    header: "Controlling Person 4 Tax Residence Country 4",
  },
  {
    field: "Controlling Person 4 Tax Residence Country 4 TIN",
    header: "Controlling Person 4 Tax Residence Country 4 TIN",
  },
  {
    field: "Controlling Person 4 Type of Controlling Person",
    header: "Controlling Person 4 Type of Controlling Person",
  },
  { field: "Controlling Person 5 First Name", header: "Controlling Person 5 First Name" },
  { field: "Controlling Person 5 Last Name", header: "Controlling Person 5 Last Name" },
  {
    field: "Controlling Person 5 Permanent Address Line1",
    header: "Controlling Person 5 Permanent Address Line1",
  },
  {
    field: "Controlling Person 5 Permanent Address Line2",
    header: "Controlling Person 5 Permanent Address Line2",
  },
  {
    field: "Controlling Person 5 Permanent Address Line3",
    header: "Controlling Person 5 Permanent Address Line3",
  },
  {
    field: "Controlling Person 5 Permanent City Town",
    header: "Controlling Person 5 Permanent City Town",
  },
  {
    field: "Controlling Person 5 Permanent State Province",
    header: "Controlling Person 5 Permanent State Province",
  },
  {
    field: "Controlling Person 5 Permanent Country",
    header: "Controlling Person 5 Permanent Country",
  },
  {
    field: "Controlling Person 5 Permanent Country Other",
    header: "Controlling Person 5 Permanent Country Other",
  },
  {
    field: "Controlling Person 5 Permanent ZIP Postal Code",
    header: "Controlling Person 5 Permanent ZIP Postal Code",
  },
  {
    field: "Controlling Person 5 Date of Birth (MM/DD/YYYY)",
    header: "Controlling Person 5 Date of Birth (MM/DD/YYYY)",
  },
  {
    field: "Controlling Person 5 Country of birth",
    header: "Controlling Person 5 Country of birth",
  },
  {
    field: "Controlling Person 5 Tax Residence Country1",
    header: "Controlling Person 5 Tax Residence Country1",
  },
  {
    field: "Controlling Person 5 Tax Residence Country 1 TIN",
    header: "Controlling Person 5 Tax Residence Country 1 TIN",
  },
  {
    field: "Controlling Person 5 Tax Residence Country 2",
    header: "Controlling Person 5 Tax Residence Country 2",
  },
  {
    field: "Controlling Person 5 Tax Residence Country 2 TIN",
    header: "Controlling Person 5 Tax Residence Country 2 TIN",
  },
  {
    field: "Controlling Person 5 Tax Residence Country 3",
    header: "Controlling Person 5 Tax Residence Country 3",
  },
  {
    field: "Controlling Person 5 Tax Residence Country 3 TIN",
    header: "Controlling Person 5 Tax Residence Country 3 TIN",
  },
  {
    field: "Controlling Person 5 Tax Residence Country 4",
    header: "Controlling Person 5 Tax Residence Country 4",
  },
  {
    field: "Controlling Person 5 Tax Residence Country 4 TIN",
    header: "Controlling Person 5 Tax Residence Country 4 TIN",
  },
  {
    field: "Controlling Person 5 Type of Controlling Person",
    header: "Controlling Person 5 Type of Controlling Person",
  },
  { field: "Controlling Person 6 First Name", header: "Controlling Person 6 First Name" },
  { field: "Controlling Person 6 Last Name", header: "Controlling Person 6 Last Name" },
  {
    field: "Controlling Person 6 Permanent Address Line1",
    header: "Controlling Person 6 Permanent Address Line1",
  },
  {
    field: "Controlling Person 6 Permanent Address Line2",
    header: "Controlling Person 6 Permanent Address Line2",
  },
  {
    field: "Controlling Person 6 Permanent Address Line3",
    header: "Controlling Person 6 Permanent Address Line3",
  },
  {
    field: "Controlling Person 6 Permanent City Town",
    header: "Controlling Person 6 Permanent City Town",
  },
  {
    field: "Controlling Person 6 Permanent State Province",
    header: "Controlling Person 6 Permanent State Province",
  },
  {
    field: "Controlling Person 6 Permanent Country",
    header: "Controlling Person 6 Permanent Country",
  },
  {
    field: "Controlling Person 6 Permanent Country Other",
    header: "Controlling Person 6 Permanent Country Other",
  },
  {
    field: "Controlling Person 6 Permanent ZIP Postal Code",
    header: "Controlling Person 6 Permanent ZIP Postal Code",
  },
  {
    field: "Controlling Person 6 Date of Birth (MM/DD/YYYY)",
    header: "Controlling Person 6 Date of Birth (MM/DD/YYYY)",
  },
  {
    field: "Controlling Person 6 Country of birth",
    header: "Controlling Person 6 Country of birth",
  },
  {
    field: "Controlling Person 6 Tax Residence Country 1",
    header: "Controlling Person 6 Tax Residence Country 1",
  },
  {
    field: "Controlling Person 6 Tax Residence Country 1 TIN",
    header: "Controlling Person 6 Tax Residence Country 1 TIN",
  },
  {
    field: "Controlling Person 6 Tax Residence Country 2",
    header: "Controlling Person 6 Tax Residence Country 2",
  },
  {
    field: "Controlling Person 6 Tax Residence Country 2 TIN",
    header: "Controlling Person 6 Tax Residence Country 2 TIN",
  },
  {
    field: "Controlling Person 6 Tax Residence Country 3",
    header: "Controlling Person 6 Tax Residence Country 3",
  },
  {
    field: "Controlling Person 6 Tax Residence Country 3 TIN",
    header: "Controlling Person 6 Tax Residence Country 3 TIN",
  },
  {
    field: "Controlling Person 6 Tax Residence Country 4",
    header: "Controlling Person 6 Tax Residence Country 4",
  },
  {
    field: "Controlling Person 6 Tax Residence Country 4 TIN",
    header: "Controlling Person 6 Tax Residence Country 4 TIN",
  },
  {
    field: "Controlling Person 6 Type of Controlling Person",
    header: "Controlling Person 6 Type of Controlling Person",
  },
  { field: "Controlling Person 7 First Name", header: "Controlling Person 7 First Name" },
  { field: "Controlling Person 7 Last Name", header: "Controlling Person 7 Last Name" },
  {
    field: "Controlling Person 7 Permanent Address Line1",
    header: "Controlling Person 7 Permanent Address Line1",
  },
  {
    field: "Controlling Person 7 Permanent Address Line2",
    header: "Controlling Person 7 Permanent Address Line2",
  },
  {
    field: "Controlling Person 7 Permanent Address Line3",
    header: "Controlling Person 7 Permanent Address Line3",
  },
  {
    field: "Controlling Person 7 Permanent City Town",
    header: "Controlling Person 7 Permanent City Town",
  },
  {
    field: "Controlling Person 7 Permanent State Province",
    header: "Controlling Person 7 Permanent State Province",
  },
  {
    field: "Controlling Person 7 Permanent Country",
    header: "Controlling Person 7 Permanent Country",
  },
  {
    field: "Controlling Person 7 Permanent Country Other",
    header: "Controlling Person 7 Permanent Country Other",
  },
  {
    field: "Controlling Person 7 Permanent ZIP Postal Code",
    header: "Controlling Person 7 Permanent ZIP Postal Code",
  },
  {
    field: "Controlling Person 7 Date of Birth (MM/DD/YYYY)",
    header: "Controlling Person 7 Date of Birth (MM/DD/YYYY)",
  },
  {
    field: "Controlling Person 7 Country of birth",
    header: "Controlling Person 7 Country of birth",
  },
  {
    field: "Controlling Person 7 Tax Residence Country1",
    header: "Controlling Person 7 Tax Residence Country1",
  },
  {
    field: "Controlling Person 7 Tax Residence Country 1 TIN",
    header: "Controlling Person 7 Tax Residence Country 1 TIN",
  },
  {
    field: "Controlling Person 7 Tax Residence Country 2",
    header: "Controlling Person 7 Tax Residence Country 2",
  },
  {
    field: "Controlling Person 7 Tax Residence Country 2 TIN",
    header: "Controlling Person 7 Tax Residence Country 2 TIN",
  },
  {
    field: "Controlling Person 7 Tax Residence Country 3",
    header: "Controlling Person 7 Tax Residence Country 3",
  },
  {
    field: "Controlling Person 7 Tax Residence Country 3 TIN",
    header: "Controlling Person 7 Tax Residence Country 3 TIN",
  },
  {
    field: "Controlling Person 7 Tax Residence Country 4",
    header: "Controlling Person 7 Tax Residence Country 4",
  },
  {
    field: "Controlling Person 7 Tax Residence Country 4 TIN",
    header: "Controlling Person 7 Tax Residence Country 4 TIN",
  },
  {
    field: "Controlling Person 7 Type of Controlling Person",
    header: "Controlling Person 7 Type of Controlling Person",
  },
  { field: "Controlling Person 8 First Name", header: "Controlling Person 8 First Name" },
  { field: "Controlling Person 8 Last Name", header: "Controlling Person 8 Last Name" },
  {
    field: "Controlling Person 8 Permanent Address Line1",
    header: "Controlling Person 8 Permanent Address Line1",
  },
  {
    field: "Controlling Person 8 Permanent Address Line2",
    header: "Controlling Person 8 Permanent Address Line2",
  },
  {
    field: "Controlling Person 8 Permanent Address Line3",
    header: "Controlling Person 8 Permanent Address Line3",
  },
  {
    field: "Controlling Person 8 Permanent City Town",
    header: "Controlling Person 8 Permanent City Town",
  },
  {
    field: "Controlling Person 8 Permanent State Province",
    header: "Controlling Person 8 Permanent State Province",
  },
  {
    field: "Controlling Person 8 Permanent Country",
    header: "Controlling Person 8 Permanent Country",
  },
  {
    field: "Controlling Person 8 Permanent Country Other",
    header: "Controlling Person 8 Permanent Country Other",
  },
  {
    field: "Controlling Person 8 Permanent ZIP Postal Code",
    header: "Controlling Person 8 Permanent ZIP Postal Code",
  },
  {
    field: "Controlling Person 8 Date of Birth (MM/DD/YYYY)",
    header: "Controlling Person 8 Date of Birth (MM/DD/YYYY)",
  },
  {
    field: "Controlling Person 8 Country of birth",
    header: "Controlling Person 8 Country of birth",
  },
  {
    field: "Controlling Person 8 Tax Residence Country1",
    header: "Controlling Person 8 Tax Residence Country1",
  },
  {
    field: "Controlling Person 8 Tax Residence Country 1 TIN",
    header: "Controlling Person 8 Tax Residence Country 1 TIN",
  },
  {
    field: "Controlling Person 8 Tax Residence Country 2",
    header: "Controlling Person 8 Tax Residence Country 2",
  },
  {
    field: "Controlling Person 8 Tax Residence Country 2 TIN",
    header: "Controlling Person 8 Tax Residence Country 2 TIN",
  },
  {
    field: "Controlling Person 8 Tax Residence Country 3",
    header: "Controlling Person 8 Tax Residence Country 3",
  },
  {
    field: "Controlling Person 8 Tax Residence Country 3 TIN",
    header: "Controlling Person 8 Tax Residence Country 3 TIN",
  },
  {
    field: "Controlling Person 8 Tax Residence Country 4",
    header: "Controlling Person 8 Tax Residence Country 4",
  },
  {
    field: "Controlling Person 8 Tax Residence Country 4 TIN",
    header: "Controlling Person 8 Tax Residence Country 4 TIN",
  },
  {
    field: "Controlling Person 8 Type of Controlling Person",
    header: "Controlling Person 8 Type of Controlling Person",
  },
  { field: "Controlling Person 9 First Name", header: "Controlling Person 9 First Name" },
  { field: "Controlling Person 9 Last Name", header: "Controlling Person 9 Last Name" },
  {
    field: "Controlling Person 9 Permanent Address Line1",
    header: "Controlling Person 9 Permanent Address Line1",
  },
  {
    field: "Controlling Person 9 Permanent Address Line2",
    header: "Controlling Person 9 Permanent Address Line2",
  },
  {
    field: "Controlling Person 9 Permanent Address Line3",
    header: "Controlling Person 9 Permanent Address Line3",
  },
  {
    field: "Controlling Person 9 Permanent City Town",
    header: "Controlling Person 9 Permanent City Town",
  },
  {
    field: "Controlling Person 9 Permanent State Province",
    header: "Controlling Person 9 Permanent State Province",
  },
  {
    field: "Controlling Person 9 Permanent Country",
    header: "Controlling Person 9 Permanent Country",
  },
  {
    field: "Controlling Person 9 Permanent Country Other",
    header: "Controlling Person 9 Permanent Country Other",
  },
  {
    field: "Controlling Person 9 Permanent ZIP Postal Code",
    header: "Controlling Person 9 Permanent ZIP Postal Code",
  },
  {
    field: "Controlling Person 9 Date of Birth (MM/DD/YYYY)",
    header: "Controlling Person 9 Date of Birth (MM/DD/YYYY)",
  },
  {
    field: "Controlling Person 9 Country of birth",
    header: "Controlling Person 9 Country of birth",
  },
  {
    field: "Controlling Person 9 Tax Residence Country1",
    header: "Controlling Person 9 Tax Residence Country1",
  },
  {
    field: "Controlling Person 9 Tax Residence Country 1 TIN",
    header: "Controlling Person 9 Tax Residence Country 1 TIN",
  },
  {
    field: "Controlling Person 9 Tax Residence Country 2",
    header: "Controlling Person 9 Tax Residence Country 2",
  },
  {
    field: "Controlling Person 9 Tax Residence Country 2 TIN",
    header: "Controlling Person 9 Tax Residence Country 2 TIN",
  },
  {
    field: "Controlling Person 9 Tax Residence Country 3",
    header: "Controlling Person 9 Tax Residence Country 3",
  },
  {
    field: "Controlling Person 9 Tax Residence Country 3 TIN",
    header: "Controlling Person 9 Tax Residence Country 3 TIN",
  },
  {
    field: "Controlling Person 9 Tax Residence Country 4",
    header: "Controlling Person 9 Tax Residence Country 4",
  },
  {
    field: "Controlling Person 9 Tax Residence Country 4 TIN",
    header: "Controlling Person 9 Tax Residence Country 4 TIN",
  },
  {
    field: "Controlling Person 9 Type of Controlling Person",
    header: "Controlling Person 9 Type of Controlling Person",
  },
  { field: "Controlling Person 10 First Name", header: "Controlling Person 10 First Name" },
  { field: "Controlling Person 10 Last Name", header: "Controlling Person 10 Last Name" },
  {
    field: "Controlling Person 10 Permanent Address Line1",
    header: "Controlling Person 10 Permanent Address Line1",
  },
  {
    field: "Controlling Person 10 Permanent Address Line2",
    header: "Controlling Person 10 Permanent Address Line2",
  },
  {
    field: "Controlling Person 10 Permanent Address Line3",
    header: "Controlling Person 10 Permanent Address Line3",
  },
  {
    field: "Controlling Person 10 Permanent City Town",
    header: "Controlling Person 10 Permanent City Town",
  },
  {
    field: "Controlling Person 10 Permanent State Province",
    header: "Controlling Person 10 Permanent State Province",
  },
  {
    field: "Controlling Person 10 Permanent Country",
    header: "Controlling Person 10 Permanent Country",
  },
  {
    field: "Controlling Person 10 Permanent Country Other",
    header: "Controlling Person 10 Permanent Country Other",
  },
  {
    field: "Controlling Person 10 Permanent ZIP Postal Code",
    header: "Controlling Person 10 Permanent ZIP Postal Code",
  },
  {
    field: "Controlling Person 10 Date of Birth (MM/DD/YYYY)",
    header: "Controlling Person 10 Date of Birth (MM/DD/YYYY)",
  },
  {
    field: "Controlling Person 10 Country of birth",
    header: "Controlling Person 10 Country of birth",
  },
  {
    field: "Controlling Person 10 Tax Residence Country1",
    header: "Controlling Person 10 Tax Residence Country1",
  },
  {
    field: "Controlling Person 10 Tax Residence Country 1 TIN",
    header: "Controlling Person 10 Tax Residence Country 1 TIN",
  },
  {
    field: "Controlling Person 10 Tax Residence Country 2",
    header: "Controlling Person 10 Tax Residence Country 2",
  },
  {
    field: "Controlling Person 10 Tax Residence Country 2 TIN",
    header: "Controlling Person 10 Tax Residence Country 2 TIN",
  },
  {
    field: "Controlling Person 10 Tax Residence Country 3",
    header: "Controlling Person 10 Tax Residence Country 3",
  },
  {
    field: "Controlling Person 10 Tax Residence Country 3 TIN",
    header: "Controlling Person 10 Tax Residence Country 3 TIN",
  },
  {
    field: "Controlling Person 10 Tax Residence Country 4",
    header: "Controlling Person 10 Tax Residence Country 4",
  },
  {
    field: "Controlling Person 10 Tax Residence Country 4 TIN",
    header: "Controlling Person 10 Tax Residence Country 4 TIN",
  },
  {
    field: "Controlling Person 10 Type of Controlling Person",
    header: "Controlling Person 10 Type of Controlling Person",
  },
  { field: "Substantial US Owners1 Name", header: "Substantial US Owners1 Name" },
  {
    field: "Substantial US Owners 1 Address Line1",
    header: "Substantial US Owners 1 Address Line1",
  },
  { field: "Substantial US Owners1 Address Line2", header: "Substantial US Owners1 Address Line2" },
  { field: "Substantial US Owners 1 City Town", header: "Substantial US Owners 1 City Town" },
  {
    field: "Substantial US Owners 1 State Province",
    header: "Substantial US Owners 1 State Province",
  },
  { field: "Substantial US Owners 1 Country", header: "Substantial US Owners 1 Country" },
  { field: "Substantial US Owners1 Country Other", header: "Substantial US Owners1 Country Other" },
  {
    field: "Substantial US Owners 1 Zip Postal Code",
    header: "Substantial US Owners 1 Zip Postal Code",
  },
  { field: "Substantial US Owners 1 TIN Type", header: "Substantial US Owners 1 TIN Type" },
  { field: "Substantial US Owners 1 TIN", header: "Substantial US Owners 1 TIN" },
  {
    field: "Substantial US Owners1 Percentage Allocation",
    header: "Substantial US Owners1 Percentage Allocation",
  },
  { field: "Substantial US Owners 2 Name", header: "Substantial US Owners 2 Name" },
  {
    field: "Substantial US Owners 2 Address Line 1",
    header: "Substantial US Owners 2 Address Line 1",
  },
  {
    field: "Substantial US Owners 2 Address Line 2",
    header: "Substantial US Owners 2 Address Line 2",
  },
  { field: "Substantial US Owners 2 City Town", header: "Substantial US Owners 2 City Town" },
  {
    field: "Substantial US Owners 2 State Province",
    header: "Substantial US Owners 2 State Province",
  },
  { field: "Substantial US Owners 2 Country", header: "Substantial US Owners 2 Country" },
  {
    field: "Substantial US Owners 2 Country Other",
    header: "Substantial US Owners 2 Country Other",
  },
  {
    field: "Substantial US Owners 2 Zip Postal Code",
    header: "Substantial US Owners 2 Zip Postal Code",
  },
  { field: "Substantial US Owners 2 TIN Type", header: "Substantial US Owners 2 TIN Type" },
  { field: "Substantial US Owners 2 TIN", header: "Substantial US Owners 2 TIN" },
  {
    field: "Substantial US Owners 2 Percentage Allocation",
    header: "Substantial US Owners 2 Percentage Allocation",
  },
  { field: "Substantial US Owners 3 Name", header: "Substantial US Owners 3 Name" },
  {
    field: "Substantial US Owners 3 Address Line1",
    header: "Substantial US Owners 3 Address Line1",
  },
  {
    field: "Substantial US Owners 3 Address Line2",
    header: "Substantial US Owners 3 Address Line2",
  },
  { field: "Substantial US Owners 3 City Town", header: "Substantial US Owners 3 City Town" },
  {
    field: "Substantial US Owners 3 State Province",
    header: "Substantial US Owners 3 State Province",
  },
  { field: "Substantial US Owners 3 Country", header: "Substantial US Owners 3 Country" },
  {
    field: "Substantial US Owners 3 Country Other",
    header: "Substantial US Owners 3 Country Other",
  },
  {
    field: "Substantial US Owners 3 Zip Postal Code",
    header: "Substantial US Owners 3 Zip Postal Code",
  },
  {
    field: "Column4Substantial US Owners 3 TIN Type",
    header: "Column4Substantial US Owners 3 TIN Type",
  },
  { field: "Substantial US Owners 3 TIN", header: "Substantial US Owners 3 TIN" },
  {
    field: "Substantial US Owners 3 Percentage Allocation",
    header: "Substantial US Owners 3 Percentage Allocation",
  },
  { field: "Substantial US Owners 4 Name", header: "Substantial US Owners 4 Name" },
  {
    field: "Substantial US Owners 4 Address Line1",
    header: "Substantial US Owners 4 Address Line1",
  },
  {
    field: "Substantial US Owners 4 Address Line2",
    header: "Substantial US Owners 4 Address Line2",
  },
  { field: "Substantial US Owners 4 City Town", header: "Substantial US Owners 4 City Town" },
  {
    field: "Substantial US Owners 4 State Province",
    header: "Substantial US Owners 4 State Province",
  },
  { field: "Substantial US Owners 4 Country", header: "Substantial US Owners 4 Country" },
  {
    field: "Substantial US Owners 4 Country Other",
    header: "Substantial US Owners 4 Country Other",
  },
  {
    field: "Substantial US Owners 4 Zip Postal Code",
    header: "Substantial US Owners 4 Zip Postal Code",
  },
  { field: "Substantial US Owners 4 TIN Type", header: "Substantial US Owners 4 TIN Type" },
  { field: "Substantial US Owners 4 TIN", header: "Substantial US Owners 4 TIN" },
  {
    field: "Substantial US Owners 4 Percentage Allocation",
    header: "Substantial US Owners 4 Percentage Allocation",
  },
  { field: "Substantial US Owners 5 Name", header: "Substantial US Owners 5 Name" },
  {
    field: "Substantial US Owners 5 Address Line1",
    header: "Substantial US Owners 5 Address Line1",
  },
  {
    field: "Substantial US Owners 5 Address Line2",
    header: "Substantial US Owners 5 Address Line2",
  },
  { field: "Substantial US Owners 5 City Town", header: "Substantial US Owners 5 City Town" },
  {
    field: "Substantial US Owners 5 State Province",
    header: "Substantial US Owners 5 State Province",
  },
  { field: "Substantial US Owners 5 Country", header: "Substantial US Owners 5 Country" },
  {
    field: "Substantial US Owners 5 Country Other",
    header: "Substantial US Owners 5 Country Other",
  },
  {
    field: "Substantial US Owners 5 Zip Postal Code",
    header: "Substantial US Owners 5 Zip Postal Code",
  },
  { field: "Substantial US Owners 5 TIN Type", header: "Substantial US Owners 5 TIN Type" },
  { field: "Substantial US Owners 5 TIN", header: "Substantial US Owners 5 TIN" },
  {
    field: "Substantial US Owners 5 Percentage Allocation",
    header: "Substantial US Owners 5 Percentage Allocation",
  },
  { field: "Substantial US Owners 6 Name", header: "Substantial US Owners 6 Name" },
  {
    field: "Substantial US Owners 6 Address Line1",
    header: "Substantial US Owners 6 Address Line1",
  },
  {
    field: "Substantial US Owners 6 Address Line2",
    header: "Substantial US Owners 6 Address Line2",
  },
  { field: "Substantial US Owners 6 City Town", header: "Substantial US Owners 6 City Town" },
  {
    field: "Substantial US Owners 6 State Province",
    header: "Substantial US Owners 6 State Province",
  },
  { field: "Substantial US Owners 6 Country", header: "Substantial US Owners 6 Country" },
  {
    field: "Substantial US Owners 6 Country Other",
    header: "Substantial US Owners 6 Country Other",
  },
  {
    field: "Substantial US Owners 6 Zip Postal Code",
    header: "Substantial US Owners 6 Zip Postal Code",
  },
  { field: "Substantial US Owners 6 TIN Type", header: "Substantial US Owners 6 TIN Type" },
  { field: "Substantial US Owners 6 TIN", header: "Substantial US Owners 6 TIN" },
  {
    field: "Substantial US Owners 6 Percentage Allocation",
    header: "Substantial US Owners 6 Percentage Allocation",
  },
  { field: "Substantial US Owners 7 Name", header: "Substantial US Owners 7 Name" },
  {
    field: "Substantial US Owners 7 Address Line1",
    header: "Substantial US Owners 7 Address Line1",
  },
  {
    field: "Substantial US Owners 7 Address Line2",
    header: "Substantial US Owners 7 Address Line2",
  },
  { field: "Substantial US Owners 7 City Town", header: "Substantial US Owners 7 City Town" },
  {
    field: "Substantial US Owners 7 State Province",
    header: "Substantial US Owners 7 State Province",
  },
  { field: "Substantial US Owners 7 Country", header: "Substantial US Owners 7 Country" },
  {
    field: "Substantial US Owners 7 Country Other",
    header: "Substantial US Owners 7 Country Other",
  },
  {
    field: "Substantial US Owners 7 Zip Postal Code",
    header: "Substantial US Owners 7 Zip Postal Code",
  },
  { field: "Substantial US Owners 7 TIN Type", header: "Substantial US Owners 7 TIN Type" },
  { field: "Substantial US Owners 7 TIN", header: "Substantial US Owners 7 TIN" },
  {
    field: "Substantial US Owners 7 Percentage Allocation",
    header: "Substantial US Owners 7 Percentage Allocation",
  },
  { field: "Substantial US Owners 8 Name", header: "Substantial US Owners 8 Name" },
  {
    field: "Substantial US Owners 8 Address Line1",
    header: "Substantial US Owners 8 Address Line1",
  },
  {
    field: "Substantial US Owners 8 Address Line2",
    header: "Substantial US Owners 8 Address Line2",
  },
  { field: "Substantial US Owners 8 City Town", header: "Substantial US Owners 8 City Town" },
  {
    field: "Substantial US Owners 8 State Province",
    header: "Substantial US Owners 8 State Province",
  },
  { field: "Substantial US Owners 8 Country", header: "Substantial US Owners 8 Country" },
  {
    field: "Substantial US Owners 8 Country Other",
    header: "Substantial US Owners 8 Country Other",
  },
  {
    field: "Substantial US Owners 8 Zip Postal Code",
    header: "Substantial US Owners 8 Zip Postal Code",
  },
  { field: "Substantial US Owners 8 TIN Type", header: "Substantial US Owners 8 TIN Type" },
  { field: "Substantial US Owners 8 TIN", header: "Substantial US Owners 8 TIN" },
  {
    field: "Substantial US Owners 8 Percentage Allocation",
    header: "Substantial US Owners 8 Percentage Allocation",
  },
  { field: "Substantial US Owners 9 Name", header: "Substantial US Owners 9 Name" },
  {
    field: "Substantial US Owners 9 Address Line1",
    header: "Substantial US Owners 9 Address Line1",
  },
  {
    field: "Substantial US Owners 9 Address Line2",
    header: "Substantial US Owners 9 Address Line2",
  },
  { field: "Substantial US Owners 9 City Town", header: "Substantial US Owners 9 City Town" },
  {
    field: "Substantial US Owners 9 State Province",
    header: "Substantial US Owners 9 State Province",
  },
  { field: "Substantial US Owners 9 Country", header: "Substantial US Owners 9 Country" },
  {
    field: "Substantial US Owners 9 Country Other",
    header: "Substantial US Owners 9 Country Other",
  },
  {
    field: "Substantial US Owners 9 Zip Postal Code",
    header: "Substantial US Owners 9 Zip Postal Code",
  },
  { field: "Substantial US Owners 9 TIN Type", header: "Substantial US Owners 9 TIN Type" },
  { field: "Substantial US Owners 9 TIN", header: "Substantial US Owners 9 TIN" },
  {
    field: "Substantial US Owners 9 Percentage Allocation",
    header: "Substantial US Owners 9 Percentage Allocation",
  },
  { field: "Substantial US Owners 10 Name", header: "Substantial US Owners 10 Name" },
  {
    field: "Substantial US Owners 10 Address Line1",
    header: "Substantial US Owners 10 Address Line1",
  },
  {
    field: "Substantial US Owners 10 Address Line2",
    header: "Substantial US Owners 10 Address Line2",
  },
  { field: "Substantial US Owners 10 City Town", header: "Substantial US Owners 10 City Town" },
  {
    field: "Substantial US Owners 10 State Province",
    header: "Substantial US Owners 10 State Province",
  },
  { field: "Substantial US Owners 10 Country", header: "Substantial US Owners 10 Country" },
  {
    field: "Substantial US Owners 10 Country Other",
    header: "Substantial US Owners 10 Country Other",
  },
  {
    field: "Substantial US Owners 10 Zip Postal Code",
    header: "Substantial US Owners 10 Zip Postal Code",
  },
  { field: "Substantial US Owners 10 TIN Type", header: "Substantial US Owners 10 TIN Type" },
  { field: "Substantial US Owners 10 TIN", header: "Substantial US Owners 10 TIN" },
  {
    field: "Substantial US Owners 10 Percentage Allocation",
    header: "Substantial US Owners 10 Percentage Allocation",
  },
  { field: "Issue code1", header: "Issue Code 1" },
  { field: "Additional note1", header: "Additional Note 1" },
  { field: "Issue code2", header: "Issue Code 2" },
  { field: "Additional note2", header: "Additional Note 2" },
  { field: "Issue code3", header: "Issue Code 3" },
  { field: "Additional note3", header: "Additional Note 3" },
  { field: "Issue code4", header: "Issue Code 4" },
  { field: "Additional note4", header: "Additional Note 4" },
  { field: "Issue code5", header: "Issue Code 5" },
  { field: "Additional note5", header: "Additional Note 5" },
  { field: "Issue code6", header: "Issue Code 6" },
  { field: "Additional note6", header: "Additional Note 6" },
  { field: "Issue code7", header: "Issue Code 7" },
  { field: "Additional note7", header: "Additional Note 7" },
  { field: "Issue code8", header: "Issue Code 8" },
  { field: "Additional note8", header: "Additional Note 8" },
  { field: "Issue code9", header: "Issue Code 9" },
  { field: "Additional note9", header: "Additional Note 9" },
  { field: "Issue code10", header: "Issue Code 10" },
  { field: "Additional note10", header: "Additional Note 10" },
];
